module.exports = __webpack_public_path__ + "media/flags/ck-e52d733f.svg";